export const ATTRACTION_PHOTOS = {
  culture: [
    'photo-1555952517-2e8e729e0b44','photo-1533929736458-ca588d08c8be',
    'photo-1564507592333-c60657eea523','photo-1568797629192-789acf8e4df3',
    'photo-1558618666-fcd25c85cd64','photo-1580674684081-7617fbf3d745',
  ],
  play: [
    'photo-1513151233558-d860c5398176','photo-1560419015-7c427e8ae5ba',
    'photo-1505236858219-8359eb29e329','photo-1551632436-cbf8dd35adfa',
    'photo-1516738901171-8eb4fc13bd20','photo-1572204292164-b35ba943fca7',
  ],
  nature: [
    'photo-1490604001847-b712b0c2f967','photo-1441974231531-c6227db76b6e',
    'photo-1506905925346-21bda4d32df4','photo-1501854140801-50d01698950b',
    'photo-1559827260-dc66d52bef19','photo-1520962880247-cfaf541c8724',
  ],
  shopping: [
    'photo-1483985988355-763728e1935b','photo-1555529669-e69e7aa0ba9a',
    'photo-1441986300917-64674bd600d8','photo-1472851294608-062f824d29cc',
    'photo-1607082349566-187342175e2f','photo-1567401893414-76b7b1e5a7a5',
  ],
  food: [
    'photo-1504674900247-0877df9cc836','photo-1555396273-367ea4eb4db5',
    'photo-1414235077428-338989a2e8c0','photo-1565299624946-b28f40a0ae38',
    'photo-1482049016688-2d3e1b311543','photo-1540189549336-e6e99c3679fe',
  ],
  default: [
    'photo-1488646953014-85cb44e25828','photo-1476514525535-07fb3b4ae5f1',
    'photo-1507525428034-b723cf961d3e','photo-1502602898657-3e91760cbb34',
  ],
};

export const CITY_HERO_PHOTOS = {
  'Hong Kong':'photo-1690070767302-86a0f719a36f',
  'Tokyo':'photo-1540959733332-eab4deabeeaf',
  'Osaka':'photo-1590559899731-a382839e5549',
  'Kyoto':'photo-1493976040374-85c8e12f0c0e',
  'Seoul':'photo-1601621915196-2621bfb0cd6e',
  'Beijing':'photo-1508804185872-d7badad00f7d',
  'Shanghai':'photo-1548919973-5cef591cdbc9',
  'Singapore':'photo-1525625293386-3f8f99389edd',
  'Bangkok':'photo-1563492065599-3520f775eeed',
  'Bali':'photo-1537996194471-e657df975ab4',
  'Kuala Lumpur':'photo-1596422846543-75c6fc197f07',
  'Paris':'photo-1502602898657-3e91760cbb34',
  'London':'photo-1513635269975-59663e0ac1ad',
  'Rome':'photo-1552832230-c0197dd311b5',
  'Barcelona':'photo-1539037116277-4db20889f2d4',
  'Amsterdam':'photo-1512470876302-972faa2aa9a4',
  'New York':'photo-1496442226666-8d4d0e62e6e9',
  'Dubai':'photo-1512453979798-5ea266f8880c',
  'Sydney':'photo-1506973035872-a4ec16b8e8d9',
  'Istanbul':'photo-1524231757912-21f4fe3a7200',
  'Taipei':'photo-1470093851219-69951fcbb533',
  'Macau':'photo-1570434590351-3f9e984eb4a9',
  default:'photo-1488646953014-85cb44e25828',
};

// City color schemes for hero banners
export const CC = {
  'Hong Kong':['#0d1b2e','#1a3a5c','#e94560'],
  'Tokyo':['#1a0533','#2d1b69','#ff6b9d'],
  'Osaka':['#0f0c29','#302b63','#ff8c00'],
  'Kyoto':['#1a0a00','#4a2800','#ff6347'],
  'Seoul':['#0a0a1a','#1a2a4a','#4fc3f7'],
  'Beijing':['#1a0000','#3d0000','#ff4444'],
  'Shanghai':['#001a33','#003366','#00bcd4'],
  'Singapore':['#001a1a','#003333','#00e5ff'],
  'Bangkok':['#1a0a2e','#3d1a5c','#ffb300'],
  'Bali':['#0a1a0a','#1a4a1a','#76ff03'],
  'Paris':['#1a1a33','#33335c','#f8bbd0'],
  'London':['#0a0a1a','#1c1c3a','#90caf9'],
  'Rome':['#1a0a00','#3d1a00','#ff8f00'],
  'Barcelona':['#1a0a1a','#3d1a3d','#ffcc02'],
  'Amsterdam':['#001a33','#00264d','#80deea'],
  'New York':['#0a0a0a','#1c1c1c','#ffd700'],
  'Dubai':['#1a1000','#3d2a00','#ffc107'],
  'Sydney':['#001a33','#00264d','#29b6f6'],
  'Melbourne':['#0a1a0a','#1a3311','#a5d6a7'],
  'Istanbul':['#1a0a1a','#3d1a2e','#e91e63'],
  default:['#1a1a2e','#16213e','#0f3460'],
};

export const CAT_C = {
  culture:{bg:'#e3f2fd',text:'#1565c0'}, sight:{bg:'#e3f2fd',text:'#1565c0'},
  play:{bg:'#fff3e0',text:'#c2410c'}, nature:{bg:'#e8f5e9',text:'#2e7d32'},
  shopping:{bg:'#fce4ec',text:'#880e4f'}, food:{bg:'#fff8e1',text:'#f57f17'},
  all:{bg:'#f3e5f5',text:'#4a148c'},
};

// Filename patterns that indicate non-scenic files
export const NON_SCENIC = /map|plan|diagram|logo|icon|flag|symbol|coat|arm|seal|location|route|chart|graph|scheme|layout|aerial|satellite|portrait|headshot|stamp|poster|sign|plaque|blueprint/i;

// googleusercontent.com URLs are raw Google Maps place-photo references picked
// up by the scraper — not the official Photos API (no session token), so they
// expire and start returning 403s. Chrome then blocks the request client-side
// with ERR_BLOCKED_BY_ORB, which — empirically, on this React/Chromium combo —
// does not reliably fire each card's <img onError> fallback, leaving a
// permanently broken image on screen instead of recovering. Filtering these
// out at the point image_url enters the app (rather than depending on onError
// to catch it at render time) sidesteps that unreliability entirely.
export const isReliableImageUrl = (url) => !!url && !url.includes('googleusercontent.com');

// Module-level photo cache keyed by "name||city"
export const _photoCache = {};

export const getAttractionPhoto = (category, index) => {
  const pool = ATTRACTION_PHOTOS[category] || ATTRACTION_PHOTOS.default;
  const id = pool[index % pool.length];
  return `https://images.unsplash.com/${id}?w=400&h=260&q=80&auto=format&fit=crop`;
};

export const getCityHeroPhoto = (city, w = 1200, h = 500) => {
  const id = CITY_HERO_PHOTOS[city] || CITY_HERO_PHOTOS.default;
  return `https://images.unsplash.com/${id}?w=${w}&h=${h}&q=80&auto=format&fit=crop`;
};
